import React from "react";
import { Link } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "../../styles//Footer.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFacebook,
  faInstagram,
  faTwitter,
  faYoutube,
} from "@fortawesome/free-brands-svg-icons";
import appleStoreBadge from "../../images/apple-store.png";
import googlePlayBadge from "../../images/google-play-badge.png";
import FooterLink from "./FooterLink";
import { trackSocialClick, trackAppStoreClick } from "../../utils/analytics";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="row">
          {/* Column 1: About */}
          <div className="col-md-2">
            <h5>About Sârv</h5>
            <ul>
              <li>
                <a href="/mission">About Us</a>
              </li>
              {/* <li>
                <a href="/services">Services</a>
              </li> */}
              <li>
                <a href="/faq">FAQ</a>
              </li>
              <li>
                <a href="/careers">Careers</a>
              </li>
              {/* <li>
                <a href="#">News Coverage</a>
              </li> */}
              <li>
                <a href="/contact">Contact Us</a>
              </li>
              <li>
                <Link to="/terms-of-service">Terms of Use</Link>
              </li>
              <li>
                <Link to="/privacy-policy">Privacy Policy</Link>
              </li>
            </ul>
          </div>

          {/* Column 2: Resources — the product surfaces, as opposed to the
              editorial ones in the Articles column next door. */}
          <div className="col-md-2">
            <h5>Resources</h5>
            <ul>
              <li>
                <Link to="/atlas">The Atlas</Link>
              </li>
              <li>
                <Link to="/herbCategories">Medicinal Plants</Link>
              </li>
              <li>
                <Link to="/conditions">Conditions</Link>
              </li>
              <li>
                <Link to="/quizzes">Quizzes</Link>
              </li>
              <li>
                <Link to="/editorial-process">Editorial Process</Link>
              </li>
            </ul>
          </div>

          {/* Column 3: editorial */}
          <div className="col-md-3">
            <h5>Articles</h5>
            <ul>
              <li>
                <a href="/learn">All Articles</a>
              </li>
              <li>
                <FooterLink title="Medicinal Herbs" category="herbalism" />
              </li>
              <li>
                <FooterLink title="Women's Health" category="womens-health" />
              </li>
              <li>
                <FooterLink title="Mental Health" category="mental-health" />
              </li>
              <li>
                <FooterLink
                  title="Digestive System"
                  category="digestive-health"
                />
              </li>
              <li>
                <FooterLink title="Nutrition & Recipes" category="recipes" />
              </li>
              <li>
                <FooterLink title="Ayurveda" category="ayurveda" />
              </li>
            </ul>
          </div>

          {/* Column 4: partnerships — only two short links, so it yields a
              column to the app badges, which have an intrinsic minimum width. */}
          <div className="col-md-2">
            <h5>Business Partnership</h5>
            <ul>
              {/* <li>
                <a href="#">List Your Business</a>
              </li> */}
              <li>
                <a href="/demo-request">Sârv for Business</a>
              </li>
              <li>
                <a href="/affiliate-request">Become an Affiliate</a>
              </li>
            </ul>
          </div>

          {/* Column 5: app stores + social. 2+2+3+2+3 = 12 columns. */}
          <div className="col-md-3">
            {/* Row for App Stores */}
            <div className="app-and-social">
              {/* <p>Appstore | Googlestore</p> */}
              <div className="app-stores">
                <a
                  href="https://apps.apple.com/us/app/sarv-ai-holistic-health-coach/id6759615073"
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={() => trackAppStoreClick("Apple App Store")}
                >
                  <img
                    src={appleStoreBadge}
                    alt="Download on the Apple Store"
                  />
                </a>
              </div>
              <div className="app-stores">
                <a
                  href="https://play.google.com/store/apps/details?id=com.m31v1.sarv"
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={() => trackAppStoreClick("Google Play Store")}
                >
                  <img src={googlePlayBadge} alt="Get it on Google Play" />
                </a>
              </div>
            </div>

            {/* Row for Social Media Icons */}
            <div className="social-icons">
              <a
                href="https://www.facebook.com/joinsarv"
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => trackSocialClick("Facebook")}
              >
                <FontAwesomeIcon icon={faFacebook} />
              </a>
              <a
                href="https://www.instagram.com/joinsarv/"
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => trackSocialClick("Instagram")}
              >
                <FontAwesomeIcon icon={faInstagram} />
              </a>
              <a
                href="https://www.twitter.com/"
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => trackSocialClick("Twitter")}
              >
                <FontAwesomeIcon icon={faTwitter} />
              </a>
              <a
                href="https://www.youtube.com/"
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => trackSocialClick("YouTube")}
              >
                <FontAwesomeIcon icon={faYoutube} />
              </a>
            </div>
            <div
              className="copyright-text"
              style={{
                color: "white",
                paddingTop: "30px",
                fontSize: "12px",
                textAlign: "center",
              }}
            >
              © 2026 M31-V1 LLC. All rights reserved.
            </div>
          </div>
        </div>

        <div className="footer-disclaimer">
          Sarv is for educational and wellness purposes only and is not a
          substitute for professional medical advice, diagnosis, or treatment.
          It is not intended to diagnose, treat, cure, or prevent any disease.
        </div>
      </div>
    </footer>
  );
};

export default Footer;
